export const routes = {
  root: {
    root: "/",
  },
  admin: {
    root: "/admin",
    dashboard: {
      root: "/admin/dashboard",
    },
    administration: {
      root: "/admin/administration",
      system: {
        root: "/admin/administration/system",
      },
      debug: {
        root: "/admin/administration/debug",
      },
    },
    bill: {
      root: "/admin/bill",
      account_movements: {
        root: "/admin/bill/account-movements",
      },
    },
    import: {
      root: "/admin/products-import",
    },
    accountingExport: {
      root: "/admin/accounting-export",
    },
    balanceList: {
      root: "/admin/balance-list",
    },
  },
};
